import styleStatusMap from "@/data/styleStatusMap.json"

export function getStyle(status: string) {
  let result = Object.keys(styleStatusMap)[0]

  for (const style in styleStatusMap) {
    const statuses = styleStatusMap[style as keyof typeof styleStatusMap] as string[]
    if (statuses.includes(status)) result = style
  }

  return result
}
